import { render, staticRenderFns } from "./SettingsSmsTemplates.vue?vue&type=template&id=4f48bf3e"
import script from "./SettingsSmsTemplates.vue?vue&type=script&lang=js"
export * from "./SettingsSmsTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports